import { ChangeDetectorRef, OnDestroy, OnInit, } from '@angular/core';
import { Router } from '@angular/router';
import { AppStateFacade, Setting, } from '@app-state';
import { LICENSE_DEFINITIONS } from '@components/shared/license/license.constants';
import { ChartTooltipTrigger } from '@components/ui-chart/base-chart.types';
import { Interval, RobotType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { DEFAULT_USAGE_INTERVALS, intervalToUnit, unitToFormat, } from '@pages/shared/chart.config';
import { ChartColorService, ChartService, LicenseUsageService, ResourceMapperService, StorageService, TenantService, } from '@services';
import { unsubscribe } from '@utils/object.utils';
import constant from 'lodash-es/constant';
import findKey from 'lodash-es/findKey';
import groupBy from 'lodash-es/groupBy';
import times from 'lodash-es/times';
import values from 'lodash-es/values';
import * as moment from 'moment';
import { BehaviorSubject, combineLatest, merge, } from 'rxjs';
import { map, tap, } from 'rxjs/operators';
var UiLicenseChartComponent = /** @class */ (function () {
    function UiLicenseChartComponent(_appState, _translateService, _licenseUsageService, _chartService, _tenantService, _storageService, _cd, _router, _chartColorService) {
        var _this = this;
        this._appState = _appState;
        this._translateService = _translateService;
        this._licenseUsageService = _licenseUsageService;
        this._chartService = _chartService;
        this._tenantService = _tenantService;
        this._storageService = _storageService;
        this._cd = _cd;
        this._router = _router;
        this._chartColorService = _chartColorService;
        this.ChartTooltipTrigger = ChartTooltipTrigger;
        this.defaultUsageIntervals = DEFAULT_USAGE_INTERVALS;
        this.chart = {
            loading: true,
            hasData: false,
            data: null,
            legend: null,
            labels: null,
            colors: this._chartColorService.license,
        };
        this.defaultTenant = null;
        this._labelFormat = '';
        this.tenantsSearchFactory = function (query, fetchSize, skipNum) {
            if (query === void 0) { query = ''; }
            if (fetchSize === void 0) { fetchSize = 20; }
            if (skipNum === void 0) { skipNum = 0; }
            var queryOptions = {
                orderBy: ['Name'],
                top: fetchSize,
                skip: skipNum,
                filter: {
                    Name: {
                        contains: query,
                    },
                },
            };
            return _this._tenantService
                .get(queryOptions)
                .pipe(map(function (response) { return _this._mapTenants(response); }), tap(function (_a) {
                var _b = _a.data, data = _b === void 0 ? [] : _b;
                var tenants = data;
                if (!_this.isHost ||
                    _this.defaultTenant != null ||
                    tenants.length === 0) {
                    return;
                }
                var cachedTenant = _this._storageService.get(_this._tenantCacheKey, null);
                var defaultTenant;
                defaultTenant = cachedTenant || tenants[0];
                _this.defaultTenant = [defaultTenant];
                _this._cd.markForCheck();
            }));
        };
        this._mapTenants = function (tenants) {
            var mappedTenants = tenants.data
                .map(function (tenant) { return ({
                id: tenant.id,
                text: tenant.name,
            }); });
            return {
                data: mappedTenants,
                total: tenants.total,
            };
        };
        var buildVersion = this._appState.authConfig.buildVersion;
        var userId = this._appState.user.value.id;
        this._tenantCacheKey = buildVersion + "-" + userId + "-license-chart-tenant";
        this._intervalCacheKey = this._router.url + " chart - " + userId + " - LicenseUsage";
        this.chartInterval$ = new BehaviorSubject(this._storageService.get(this._intervalCacheKey, Interval.Week));
    }
    Object.defineProperty(UiLicenseChartComponent.prototype, "labelFormat", {
        get: function () {
            return this._labelFormat;
        },
        set: function (value) {
            this._labelFormat = unitToFormat(value);
        },
        enumerable: true,
        configurable: true
    });
    UiLicenseChartComponent.prototype.ngOnInit = function () {
        var _this = this;
        if (!this.isHost) {
            this.tenantId = this._appState.user.value.tenancyId;
        }
        this.intervalLabel$ = merge(this._appState.language.change$, this.chartInterval$).pipe(map(function (_) { return _this._chartService.getLicenseUsageLabelForInterval(_this.chartInterval$.value); }));
        this.loadChart();
    };
    UiLicenseChartComponent.prototype.ngOnDestroy = function () {
        unsubscribe(this._licenseUsageSub);
    };
    UiLicenseChartComponent.prototype.onTenantSelect = function (tenant) {
        this.tenantId = tenant.id;
        this._storageService.set(this._tenantCacheKey, tenant);
        this.loadChart();
    };
    UiLicenseChartComponent.prototype.onIntervalChange = function (licenseUsageInterval) {
        if (licenseUsageInterval !== null) {
            this.chartInterval$.next(licenseUsageInterval);
        }
        this.loadChart();
        this._storageService.set(this._intervalCacheKey, this.chartInterval$.value);
    };
    UiLicenseChartComponent.prototype.loadChart = function () {
        var _this = this;
        if (this.isHost &&
            this.tenantId == null) {
            this.chart.hasData = false;
            return;
        }
        this.chart.loading = true;
        this.labelFormat = intervalToUnit(this.chartInterval$.value);
        if (this._licenseUsageSub) {
            this._licenseUsageSub.unsubscribe();
        }
        this._licenseUsageSub =
            combineLatest([
                this._licenseUsageService
                    .getTenantStatsById(this.tenantId, this.chartInterval$.value),
                this._translateService
                    .stream(values(ResourceMapperService.robotType)),
            ])
                .subscribe(function (_a) {
                var _b;
                var licenseUsageStats = _a[0], licenseLabels = _a[1];
                if (licenseUsageStats.length > 0) {
                    _this.chart.hasData = true;
                    _b = _this._extractChartData(licenseUsageStats, licenseLabels), _this.chart.legend = _b[0], _this.chart.labels = _b[1], _this.chart.data = _b[2];
                }
                else {
                    _this.chart.hasData = false;
                }
                _this.chart.loading = false;
                _this._cd.markForCheck();
            });
    };
    UiLicenseChartComponent.prototype._extractChartData = function (data, licenseLabels) {
        var _this = this;
        var robotTypeIdsByLicenseType = [];
        var chartData = [];
        var chartLegend = [];
        var chartLabels = [];
        var groups = groupBy(data, 'robotType');
        // Datasets should match the order in licenseDefinitions.
        LICENSE_DEFINITIONS.forEach(function (licenseDefinition) {
            robotTypeIdsByLicenseType.push(findKey(RobotType, function (key) { return key.toString().toLowerCase() === licenseDefinition.key.toLowerCase(); }));
        });
        for (var _i = 0, robotTypeIdsByLicenseType_1 = robotTypeIdsByLicenseType; _i < robotTypeIdsByLicenseType_1.length; _i++) {
            var robotTypeId = robotTypeIdsByLicenseType_1[_i];
            chartLegend.push(licenseLabels[ResourceMapperService.robotType[RobotType[robotTypeId]]]);
            if (groups.hasOwnProperty(robotTypeId)) {
                chartData.push(groups[robotTypeId].map(function (singleRobotStat) { return singleRobotStat.count; }));
                if (chartLabels.length === 0) {
                    // Only extract the date labels for one license type, since all of them have the same timestamps at this point.
                    chartLabels = groups[robotTypeId].map(function (singleRobotStat) { return moment(singleRobotStat.timestamp)
                        .tz(_this._appState.settings.get(Setting.timezone))
                        .format(_this.labelFormat); });
                }
            }
            else {
                // Generate empty data for missing license types, so that they would also appear in the legend.
                chartData.push(times(groups[data[0].robotType // When this method is called, there will always be at least one item in the data array.
                ].length, // Use as template the number of datapoints generated for the first returned license type.
                constant(0)));
            }
        }
        return [chartLegend, chartLabels, chartData];
    };
    return UiLicenseChartComponent;
}());
export { UiLicenseChartComponent };
